import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-fluege.vue?vue&type=template&id=0aecc88e&scoped=true"
import script from "./reisetermin-card-vorgaenge-fluege.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-fluege.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-vorgaenge-fluege.vue?vue&type=style&index=0&id=0aecc88e&prod&lang=scss&scoped=true"
import style1 from "./reisetermin-card-vorgaenge-fluege.vue?vue&type=style&index=1&id=0aecc88e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecc88e",
  null
  
)

export default component.exports